













































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
    Card,
    Row,
    Col,
    Button,
    Dialog,
    Form,
    FormItem,
    Input,
    Select,
    Option,
    InputNumber,
} from "element-ui";
import { Getter } from "vuex-class";

Vue.use(Card);
Vue.use(Row);
Vue.use(Col);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(InputNumber);

@Component({
    name: "app-payment-account",
})
export default class PaymentAccount extends Vue {
    testAccounts = [
        {
            accountNumber: "123456789",
            balance: 10 ** 6,
        },
    ];
    dialogFormVisible = false;
    name = "";
    region = "";
    labelWidth = "120px";
    num = 0;
    @Getter("auth/profile") profile!: any;
}
